export enum FireAccountTransactionRelatedPartyTypeEnum {
  FIRE_ACCOUNT = 'FIRE_ACCOUNT',
  EXTERNAL_ACCOUNT = 'EXTERNAL_ACCOUNT',
  WITHDRAWAL_ACCOUNT = 'WITHDRAWAL_ACCOUNT',
  CARD_MERCHANT = 'CARD_MERCHANT',
  CARD_ATM = 'CARD_ATM',
}